export default "__VITE_ASSET__CmvRq3I$__"